// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b9a966cfceabdf1dcd3cf967a1d3efa6cce539aa.chunk.bundle.js";
};